import React, { useEffect, useState } from 'react';
import { Text, TextInput, Selector, Flex } from '@leverege/ui-elements';
import { Validator } from '@leverege/validator';
import S from './UserForm.css';
import C from '../Constants';
import InputGroup from './InputGroup';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
export default function UserForm(props) {
  const {
    onChange,
    data,
    errors,
    isExAcct
  } = props;
  const {
    address,
    email,
    name,
    phone
  } = data || {};
  const [states, setStates] = useState([]);
  function assembleAddressString(address) {
    const {
      address1 = '',
      address2 = '',
      city = '',
      state = '',
      zipcode = '',
      country = ''
    } = address || {};
    const addressArray = [address1, address2, city, state, zipcode, country].filter(Boolean);
    return addressArray.join(', ');
  }
  useEffect(() => {
    for (let i = 0; i < C.COUNTRIES.length; i++) {
      const country = C.COUNTRIES[i];
      if (address?.country === country.name) {
        setStates(country.states);
      }
    }
    const newAddress = {
      ...address,
      location: assembleAddressString(address)
    };
    onChange({
      data: 'address',
      value: newAddress
    });
  }, [address?.country]);
  const onChangeUserForm = ({
    data,
    value
  }) => {
    if (data.startsWith('address.')) {
      const fieldName = data.split('.')[1];
      const newAddress = {
        ...address,
        [fieldName]: value
      };
      if (fieldName === 'country') {
        newAddress.state = null;
      }
      newAddress.location = assembleAddressString(newAddress);
      onChange({
        data: 'address',
        value: newAddress
      });
      return;
    }
    onChange({
      data,
      value
    });
  };
  const newUserInputs = () => {
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(InputGroup, {
        eventData: "email",
        onChange: onChangeUserForm,
        editor: TextInput,
        editorProps: {
          placeHolder: "Enter customer's email"
        },
        value: email,
        error: errors?.email,
        title: "Account Email"
      }), /*#__PURE__*/_jsx(InputGroup, {
        eventData: "name",
        onChange: onChangeUserForm,
        editor: TextInput,
        editorProps: {
          placeHolder: "Enter customer's first and last name"
        },
        value: name,
        error: errors?.name,
        title: "Full Name"
      }), /*#__PURE__*/_jsx(InputGroup, {
        eventData: "phone",
        onChange: onChangeUserForm,
        editor: TextInput,
        editorProps: {
          placeHolder: "Enter customer's phone number"
        },
        value: phone,
        error: errors?.phone,
        title: "Phone Number"
      })]
    });
  };
  return isExAcct && !data?.email ? null : /*#__PURE__*/_jsxs(Flex, {
    variant: "colM",
    children: [isExAcct ? /*#__PURE__*/_jsx(Text, {
      className: S.text,
      variant: "bodyBold",
      children: "Street Address"
    }) : null, /*#__PURE__*/_jsx(Text, {
      variant: "body",
      children: isExAcct ? 'Please confirm this street address is correct.' : 'Create a new customer account below. Their account email will be used to invite them to the RecovR application.'
    }), !isExAcct ? newUserInputs() : null, /*#__PURE__*/_jsx(InputGroup, {
      eventData: "address.address1",
      onChange: onChangeUserForm,
      editor: TextInput,
      editorProps: {
        placeHolder: 'Enter street address'
      },
      value: address?.address1,
      error: errors?.address1,
      title: "Street Address"
    }), /*#__PURE__*/_jsx(InputGroup, {
      eventData: "address.address2",
      onChange: onChangeUserForm,
      editor: TextInput,
      editorProps: {
        placeHolder: 'Enter apt/suite #'
      },
      value: address?.address2,
      error: errors?.address2,
      title: "Address Line 2"
    }), /*#__PURE__*/_jsxs(Flex, {
      variant: "rowL",
      justify: "stretch",
      children: [/*#__PURE__*/_jsx("div", {
        className: S.halfWidthContainer,
        children: /*#__PURE__*/_jsx(InputGroup, {
          eventData: "address.city",
          onChange: onChangeUserForm,
          editor: TextInput,
          editorProps: {
            placeHolder: 'e.g. New York City'
          },
          value: address?.city,
          error: errors?.city,
          title: "City"
        })
      }), /*#__PURE__*/_jsx("div", {
        className: S.halfWidthContainer,
        children: /*#__PURE__*/_jsx(InputGroup, {
          eventData: "address.zipcode",
          onChange: onChangeUserForm,
          editor: TextInput,
          editorProps: {
            placeHolder: 'e.g. 30009'
          },
          value: address?.zipcode,
          error: errors?.zipcode,
          title: "Zipcode"
        })
      })]
    }), /*#__PURE__*/_jsxs(Flex, {
      variant: "rowL",
      justify: "stretch",
      children: [/*#__PURE__*/_jsx("div", {
        className: S.halfWidthContainer,
        children: /*#__PURE__*/_jsx(InputGroup, {
          eventData: "address.country",
          onChange: onChangeUserForm,
          editor: Selector,
          editorProps: {
            values: C.COUNTRIES,
            valueKey: 'name'
          },
          value: address?.country,
          error: errors?.country,
          title: "Country"
        })
      }), /*#__PURE__*/_jsx("div", {
        className: S.halfWidthContainer,
        children: /*#__PURE__*/_jsx(InputGroup, {
          eventData: "address.state",
          onChange: onChangeUserForm,
          editor: Selector,
          editorProps: {
            values: states,
            showFilter: true
          },
          value: address?.state,
          error: errors?.state,
          title: "State"
        })
      })]
    })]
  });
}
export const useUserFormErrors = props => {
  const {
    data = {},
    isExAcct
  } = props;
  const [errors, setErrors] = useState({});
  const [validateOnDataChange, setValidateOnDataChange] = useState(false);
  const getValidationErrors = () => {
    const {
      address1,
      city,
      state,
      country,
      zipcode
    } = data?.address || {};
    const emailError = Validator.isEmail(data?.email) ? null : 'Invalid email address';
    const nameError = Validator.required(data?.name) ? null : 'Invalid name';
    const phoneError = Validator.isPhone(data?.phone) ? null : 'Invalid phone number';
    const stateError = Validator.required(state) ? null : 'Select a state';
    const countryError = Validator.required(country) ? null : 'Select a country';
    const address1Error = Validator.required(address1) && address1?.length <= 60 ? null : 'Invalid street address - use a maximum of 60 characters';
    const cityError = Validator.required(city) && city?.length <= 60 ? null : 'Invalid city - use a maximum of 60 characters';
    const zipcodeError = Validator.required(zipcode) && zipcode?.length >= 5 && zipcode?.length <= 15 ? null : 'Invalid zipcode - use a minimum of 5 and a maximum of 15 characters';
    let newErrors = {
      ...(address1Error && {
        address1: address1Error
      }),
      ...(cityError && {
        city: cityError
      }),
      ...(stateError && {
        state: stateError
      }),
      ...(countryError && {
        country: countryError
      }),
      ...(zipcodeError && {
        zipcode: zipcodeError
      })
    };
    if (!isExAcct) {
      newErrors = {
        ...newErrors,
        ...(emailError && {
          email: emailError
        }),
        ...(nameError && {
          name: nameError
        }),
        ...(phoneError && {
          phone: phoneError
        })
      };
    }
    setErrors(newErrors);
    return newErrors;
  };
  useEffect(() => {
    if (validateOnDataChange) {
      getValidationErrors();
    }
  }, [data]);
  return {
    errors,
    getValidationErrors,
    setErrors,
    setValidateOnDataChange
  };
};